import React, { useState, useEffect } from "react";
import "../product.scss";
import { AddIconBlue, DeleteIcon } from "../../../../assets/images/svg/svg";
import { customSelect } from "../../../../Utils/CommonUtils";
import Select from "react-select";
import {
  deleteProductToOemMapping,
  getAllAccessibleOemForProduct,
  getDropdownDataForOem,
  getOemData,
  getProductToOemData,
} from "../ProductService";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../common/Toaster/Toaster";

const initialData = [];

const Oem = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState(initialData);
  const [newRow, setNewRow] = useState({ name: "", logo: "", description: "" });
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [images, setImages] = useState({});
  const [descriptions, setDescriptions] = useState({});
  const selectOptions = useSelector(
    (state) => state.product.selectedProduct.oem.oemData
  );
  const detailsData = useSelector(
    (state) => state.product.selectedProduct.oem.oemById
  );
  const oemListData = useSelector(
    (state) => state.product.selectedProduct.oem.oemListData
  );
  const prodDetailsData = useSelector(
    (state) => state.product.selectedProduct.detailsData
  );
  const triggerRender = useSelector((state) => state.common.triggerRender);

  const getBase64ImageSrc = (base64String) => {
    return `data:image/png;base64,${base64String}`;
  };

  useEffect(
    () => {
      getDropdownDataForOem(
        prodDetailsData.entityid,
        prodDetailsData.organizationid
      );
      // getProductToOemData(detailsData.entityid, prodDetailsData.entityid);
    },
    [prodDetailsData.entityid, prodDetailsData.organizationid, triggerRender],
  );

  useEffect(
    () => {
      // getDropdownDataForOem(
      //   prodDetailsData.entityid,
      //   prodDetailsData.organizationid
      // );
      getAllAccessibleOemForProduct(
        prodDetailsData.entityid,
        "OEM",
        (response) => {
          setData(
            response.map((item, index) => ({
              ...item,
              id: index + 1,
            }))
          ); // Set initial data
        }
      );
      // getProductToOemData(detailsData.entityid, prodDetailsData.entityid);
    },
    [prodDetailsData.entityid, prodDetailsData.organizationid],
  );

  // const handleAddRow = () => {
  //   // Call the add API first
  //   getProductToOemData(detailsData.entityid, prodDetailsData.entityid)
  //     .then(() => {
  //       // Once add API is successful, update the local state immediately
  //       setData([...data, { ...newRow, id: data.length + 1 }]);
  //       setNewRow({ name: "", logo: "", description: "" });

  //       // Now update the listing after adding the new row
  //       getAllAccessibleOemForProduct(
  //         prodDetailsData.entityid,
  //         "OEM",
  //         (response) => {
  //           setData(
  //             response.map((item, index) => ({
  //               ...item,
  //               id: index + 1,
  //             }))
  //           );
  //         }
  //       );
  //       setSelectedOptions(null);
  //       setImages({});
  //       setDescriptions({});
  //     })
  //     .catch((error) => {
  //       console.error("Error adding row:", error);
  //     });
  // };

  const handleAddRow = () => {
    // Check if newRow.name is empty or selectedOptions is null
    if (!newRow.name || !selectedOptions) {
      // Handle case where selection is not valid (optional: show error message)
      return;
    }

    // Call the add API first
    getProductToOemData(detailsData?.entityid, prodDetailsData?.entityid)
      .then(() => {
        // Once add API is successful, update the local state immediately
        setData([...data, { ...newRow, id: data.length + 1 }]);
        setNewRow({ name: "", logo: "", description: "" });

        // Now update the listing after adding the new row
        getAllAccessibleOemForProduct(
          prodDetailsData.entityid,
          "OEM",
          (response) => {
            setData(
              response.map((item, index) => ({
                ...item,
                id: index + 1,
              }))
            );
          }
        );
        setSelectedOptions(null);
        setImages({});
        setDescriptions({});
      })
      .catch((error) => {
        console.error("Error adding row:", error);
      });
  };

  const handleDeleteRow = (entityid) => {
    deleteProductToOemMapping(entityid, prodDetailsData.entityid)
      .then(() => {
        showToast("Deleted successfully", "success");
        // Filter out the deleted row from the local state
        const updatedData = data.filter((item) => item.entityid !== entityid);
        setData(updatedData);

        // Fetch the updated data from the server to ensure consistency
        getAllAccessibleOemForProduct(
          prodDetailsData.entityid,
          "OEM",
          (response) => {
            setData(
              response.map((item, index) => ({
                ...item,
                id: index + 1,
              }))
            );
          }
        );
      })
      .catch((error) => {
        console.error("Error deleting row:", error);
      });
  };

  const handleChange = (selectedOption, index, isNew = false) => {
    if (isNew) {
      setNewRow({
        ...newRow,
        name: selectedOption.label,
        entityid: selectedOption.entityid,
      });

      getOemData(selectedOption.entityid, "OEM").then((response) => {
        setImages({ ...images, new: response.file_object });
        setDescriptions({ ...descriptions, new: response.description });
      });
      setSelectedOptions(selectedOption);
    } else {
      const newSelectedOptions = {
        ...selectedOptions,
        [index]: selectedOption,
      };
      setSelectedOptions(newSelectedOptions);
      const newData = [...data];
      newData[index] = {
        ...newData[index],
        name: selectedOption.label,
        entityid: selectedOption.entityid,
      };
      setData(newData);

      getOemData(selectedOption.entityid, "OEM").then((response) => {
        const newImages = { ...images, [index]: response.file_object };
        const newDescriptions = {
          ...descriptions,
          [index]: response.description,
        };
        setImages(newImages);
        setDescriptions(newDescriptions);
      });
    }
  };

  return (
    <div className="oem-container">
      <table className="oem-table">
        <thead>
          <tr>
            <th className="col-name">Name</th>
            <th className="col-logo">Logo</th>
            <th className="col-description">Description</th>
            <th className="col-action"></th>
            {/* <th className="col-action"></th> */}
          </tr>
        </thead>
        <tbody className="table-body-wrapper">
          {data.map((item, index) => (
            <tr key={item.entityid}>
              <td className="col-name">
                <input
                  className="form-control"
                  type="text"
                  name="name"
                  value={item.name}
                  readOnly
                  disabled
                />
              </td>
              <td className="col-logo">
                {images[index] ? (
                  <img
                    src={getBase64ImageSrc(images[index])}
                    alt="Logo"
                    className="logo-image"
                  />
                ) : item.file_object ? (
                  <img
                    src={getBase64ImageSrc(item.file_object)}
                    alt="Logo"
                    className="logo-image"
                  />
                ) : null}
              </td>
              <td className="col-description">
                {descriptions[index] || item.description}
              </td>
              {/* <td className="col-action">
                <div className="oem-action-buttons">
                  {index === data.length && (
                    <span onClick={handleAddRow}>
                      <AddIconBlue />
                    </span>
                  )}
                </div>
              </td>
              <td className="col-action">
                <span onClick={() => handleDeleteRow(item.entityid)}>
                  <DeleteIcon />
                </span>
              </td> */}
              <td className="col-action">
                <div className="oem-action-buttons">
                  {index === data.length && (
                    <span onClick={handleAddRow}>
                      <AddIconBlue />
                    </span>
                  )}
                  <span onClick={() => handleDeleteRow(item.entityid)}>
                    <DeleteIcon />
                  </span>
                </div>
              </td>
            </tr>
          ))}
          <tr>
            <td className="col-name">
              <Select
                placeholder="Select"
                name="name"
                options={selectOptions.map((option) => ({
                  label: option.name,
                  value: option.name,
                  entityid: option.entityid,
                }))}
                styles={customSelect}
                value={selectedOptions}
                onChange={(selectedOption) =>
                  handleChange(selectedOption, data.length, true)
                }
                menuPortalTarget={document.body}
              />
            </td>
            <td className="col-logo">
              {images.new && (
                <img
                  src={getBase64ImageSrc(images.new)}
                  alt="Logo"
                  className="logo-image"
                />
              )}
            </td>
            <td className="col-description">{descriptions.new}</td>
            <td className="col-action">
              <div className="oem-action-buttons">
                <span onClick={handleAddRow}>
                  <AddIconBlue />
                </span>
              </div>
            </td>
            {/* <td className="col-action"> */}
              {/* <span onClick={() => handleDeleteRow(newRow.entityid)}>
                <DeleteIcon />
              </span> */}
            {/* </td> */}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Oem;
